import { Box, Typography } from "@mui/material";
import React from "react";

// Helper component for consistent detail items
export const DetailItem = ({
  label,
  value,
  bold = false,
  small = false,
}: {
  label: string;
  value?: string | number;
  bold?: boolean;
  small?: boolean;
}) => (
  <Box>
    <Typography variant={small ? "caption" : "body2"} color="text.secondary" sx={{ lineHeight: 1.2 }}>
      {label}
    </Typography>
    <Typography variant={small ? "body2" : "body1"} sx={{ fontWeight: bold ? "bold" : "normal", lineHeight: 1.2 }}>
      {value || "-"}
    </Typography>
  </Box>
);
